import { REP_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'machineHours',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Machine Hours',
  },
}

const keys = {
  statKey: 'machine_hours',
  componentKeys: [REP_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
  convertTo: 'hours',
}

const machineHours = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { machineHours }
